
const { REACT_APP_STAGE } = process.env;
export const currentEnv = REACT_APP_STAGE as "dev"|"prod";